import Link from 'next/link'

const MenuButton = ({
  onClick,
  scrolled = false,
  textColor = 'background',
  name,
  link,
  className = '',
}) => {
  const base = `custom-underline group relative cursor-pointer text-center uppercase text-headerMobile md:text-buttonHeaderDesktop font-chivoMono transition-all duration-500`

  const variants = {
    olive: 'text-olive',
    background: 'text-background',
  }

  const scrolledClass = scrolled ? variants['olive'] : variants[textColor]

  if (onClick) {
    return (
      <button
        onClick={onClick}
        className={`${base} ${scrolledClass} ${className}`}
      >
        MENU
      </button>
    )
  }

  return (
    <Link
      scroll={false}
      href={link}
      className={`${base} ${scrolledClass} ${className}`}
    >
      {name}
    </Link>
  )
}

export default MenuButton
